/* Copyright (c) 2022-2024 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { useUpdateCloudAccountMutation } from "~/generated/graphql";
import { showError, showSuccess } from "~/services/toast";
import { generateActionSuccessText } from "~/tools";
import { useCloudAccount } from "../../CloudAccountProvider";
import { CloudAccountFields } from "./types";
import { getUpdateObject } from "./utils";

type Props = {
  onSuccess: () => void;
};

export function useUpdateCloudAccount({ onSuccess }: Props) {
  const { cloudAccount } = useCloudAccount();

  const [updateCloudAccountMutation, { loading }] =
    useUpdateCloudAccountMutation({
      onError: (error) => {
        showError(error.message);
      },
      onCompleted: () => {
        onSuccess();
        showSuccess(generateActionSuccessText("Cloud Account")()("updated")());
      },
    });

  function updateCloudAccount(data: CloudAccountFields) {
    cloudAccount &&
      updateCloudAccountMutation({
        variables: {
          input: {
            ...getUpdateObject(data, cloudAccount),
          },
        },
      });
  }

  return [updateCloudAccount, loading] as const;
}
